<template>
  <div class="wrapper">

    <!-- 选择 bar -->
    <we-bar v-if="!isMobile" :branchList="branchList" />
    <!-- 选择 bar 移动端 -->
    <we-bar-m v-else :branchList="branchList" />

    <!-- 分会 info -->
    <we-branch-items :isMobile="isMobile" :branchList="branchList" />

  </div>
</template>
<script>
import WeBar from './We.Bar'
import WeBarM from './We.Bar-m'
import WeBranchItems from './We.Branch.Items'

import { formatCity } from '@/util/methods'
import service from '@/service'
import { mapState } from 'vuex'

export default {
  components: {
    WeBar,
    WeBarM,
    WeBranchItems
  },
  data () {
    return {
      branchList: [], // 所有分会数据
      isOpen: false
    }
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    })
  },
  methods: {
    /**
     * 获取分会数据
     */
    getBranchInfo () {
      service.getBranchInfo()
        .then(res => {
          let data = res.list
          // let data = [...res.list, ...res.list, ...res.list, ...res.list, ...res.list]
          if (Array.isArray(data)) {
            data.forEach(item => {
              item['name'] = formatCity(item.city, item.province)
            })
            this.branchList = data
          }
        })
        .catch(err => { console.log(err) })
    }
    // mouseoverHandler ($event) {
    //   if (document.body.clientWidth < 1480 && $event.clientX > 0 && $event.clientX < 200) {
    //     this.isOpen = true
    //   } else {
    //     this.isOpen = false
    //   }
    // }
  },
  created () {
    this.getBranchInfo()
  }
}
</script>
